import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { getDeepestFirstChild } from '@lsq-frontend/common-ui';
import { ClaimService } from '@lsq-frontend/common-ui';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { map, pluck, startWith, switchMap } from 'rxjs/operators';
import { SupplyChainDirectAccountService } from './supply-chain-direct-account.service';
import { SupplyChainDirectBuyerAccountSharedService } from './supply-chain-direct-buyer-account-shared.service';
import { DashboardClaim } from '@lsq-frontend/remote-services/enterprise/common';

@Component({
    selector: 'business-units-select-page-header',
    styleUrls: ['./business-units-select-page-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    template: `
        <page-header [titleText]="title$ | async">
            <div class="buyer-account-actions">
                <form
                    id="business-units-filter-form"
                    *ngIf="supplyChainDirectAccountService.buyerKeysFormGroup && !isBuyerUser"
                    class="multi-select-wrapper"
                    [formGroup]="supplyChainDirectAccountService.buyerKeysFormGroup"
                >
                    <lsq-multi-select
                        *ngIf="
                            !!(
                                supplyChainDirectAccountService.allBusinessUnitsAsChecklistItems$
                                | async
                            )?.length
                        "
                        id="business-units-filter"
                        #multiSelectComponent
                        [options]="
                            supplyChainDirectAccountService.allBusinessUnitsAsChecklistItems$
                                | async
                                | notNull
                        "
                        [formControlName]="'buyerKeys'"
                        [group]="supplyChainDirectAccountService.buyerKeysFormGroup"
                        [selectAllText]="allBusinessUnitsI18n"
                        [placeholder]="multiSelectPlaceholderI18n"
                        [hideLabel]="true"
                    >
                    </lsq-multi-select>
                </form>
                <div
                    class="buyer-account-actions-divider"
                    *ngIf="
                        !isBuyerUser && (buyerAccountSharedService.allowDirectFileUploads$ | async)
                    "
                ></div>
                <buyer-account-upload-button
                    *ngIf="buyerAccountSharedService.allowDirectFileUploads$ | async"
                ></buyer-account-upload-button>
            </div>
        </page-header>
    `
})
export class BusinessUnitsSelectPageHeaderComponent implements OnInit {
    public isBuyerUser?: boolean;

    public readonly allBusinessUnitsI18n = this._i18n('All Business Units');
    public readonly multiSelectPlaceholderI18n = this._i18n('Select...');

    public readonly title$ = this._router.events.pipe(
        startWith({}), // Sometimes a router event doesn't fire on init.
        switchMap(() => getDeepestFirstChild(this._activatedRoute).data),
        pluck('title'),
        map((title) => (title === 'Overview' ? '' : title))
    );

    constructor(
        private _claimService: ClaimService,
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _i18n: I18n,
        public supplyChainDirectAccountService: SupplyChainDirectAccountService,
        public buyerAccountSharedService: SupplyChainDirectBuyerAccountSharedService
    ) {}

    public async ngOnInit(): Promise<void> {
        this.isBuyerUser = this._claimService.isOnSync(DashboardClaim.FinancingBuyerPortal);
    }
}
